<template>
  <div class="table">
    <v-data-table
      :headers="headers"
      :items="data"
      :items-per-page="itensPorPagina"
      class="elevation-1 table"
      :search="filtro_texto"
      :footer-props="footerProps"
      :header-props="headerProps"
    >
      <template v-slot:no-data>
        <span v-if="tab === 'producoes'">
          {{ data ? "Nenhuma produção encontrada" : "Sem dados" }}
        </span>
        <span v-if="tab === 'usuarios'">
          {{ data ? "Nenhum usuário encontrado" : "Sem dados" }}
        </span>
        <span v-if="tab === 'aprovadores'">
          {{ data ? "Sem dados para esse filtro" : "Escolha um perfil de aprovador" }}
        </span>
        <span v-if="tab === 'log'">
          {{ data ? "Nenhum log encontrado" : "Sem dados" }}
        </span>
        <span v-if="tab === 'contas'">
          {{ data ? "Nenhuma conta encontrada" : "Sem dados" }}
        </span>
        <span v-if="tab === 'palavras'">
          {{ data ? "Nenhuma palavras encontrada" : "Sem dados" }}
        </span>
        <span v-if="tab === 'enquetes'">
          {{ data ? "Nenhuma categoria encontrada" : "Sem dados" }}
        </span>
        <span v-if="tab === 'cameras'">
          {{ data ? "Nenhuma câmera encontrada" : "Escolha uma praça" }}
        </span>
      </template>
      <template v-slot:item="row">
        <tr :key="row.item.cod_producao" v-if="tab === 'producoes'">
          <td class="td-nome">{{ row.item.nome_producao || row.item.sig_producao }}</td>
          <td>
            <span class="prod-sigla-chip">{{ row.item.sig_producao }}</span>
          </td>
          <td>
            <span
              class="prod-status"
              :class="row.item.flg_ativo === 'S' ? 'prod-status--ativa' : 'prod-status--inativa'"
            >
              {{ row.item.flg_ativo === "S" ? "Ativa" : "Inativa" }}
            </span>
          </td>
          <td>{{ row.item.dsc_producao || "—" }}</td>
          <td :id="row.item.sig_producao">
            <div class="tdCampanha">
              <tr v-for="campanha in row.item.campanha" :key="campanha.cod_campanha">
                {{ campanha.cod_campanha }}
              </tr>
            </div>
          </td>
          <td class="tdActions">
            <div class="action-btn-group">
              <div class="table-action-box" @click="openModalEdicao(row.item)">
                <v-icon small>mdi-pencil</v-icon>
                <span class="table-action-label">Editar</span>
              </div>
              <ExcluirProducao
                :cod_producao="row.item.cod_producao"
                :dsc_login_producao="row.item.dsc_login_producao"
                :fetch-data="fetchData"
              />
              <CampanhaProducao :producao="row.item" />
            </div>
          </td>
        </tr>
        <tr :key="row.item.cod_usuario" v-if="tab === 'usuarios'">
          <td>{{ row.item.cod_usuario }}</td>
          <td>{{ row.item.dsc_login_usuario }}</td>
          <td>
            <tr v-for="perfil in row.item.perfis" :key="perfil.cod_perfil">
              <td>{{ perfil.dsc_perfil }}</td>
            </tr>
          </td>
        </tr>
        <tr :key="row.item.cod_aprovador_perfil" v-if="tab === 'aprovadores'">
          <td>{{ row.item.dsc_login_aprovador_perfil }}</td>
          <td class="tdActions">
            <div class="action-btn-group">
              <ExcluirAprovador
                :cod_aprovador_perfil="row.item.cod_aprovador_perfil"
                :fetchData="fetchData"
              />
            </div>
          </td>
        </tr>
        <tr :key="row.item.id" v-if="tab === 'enquetes'" class="enquete-row">
          <td>{{ row.item.dsc_nome_categoria }}</td>
          <td>{{ row.item.portal_categoria.dsc_nome }}</td>
          <td>
            <div class="janelas-list">
              <div
                v-for="config in row.item.config_atualizacao_resultados || []"
                :key="config.id"
                class="janela-row"
              >
                <span class="janela-range">{{ padHour(config.start_hour) }}h – {{ padHour(config.end_hour) }}h</span>
                <span class="janela-sep">·</span>
                <span class="janela-cadence">{{ formatCadence(config.seconds_interval) }}</span>
                <div class="janela-actions">
                  <EditarConfiguracaoUpdateEnquetes
                    :config-data="config"
                    :id-categoria="row.item.id"
                  />
                  <ModalRemoverConfiguracaoUpdateEnquetes
                    :id-categoria="row.item.id"
                    :id-config="config.id"
                  />
                </div>
              </div>
              <div v-if="!(row.item.config_atualizacao_resultados && row.item.config_atualizacao_resultados.length)" class="janela-empty">
                Nenhuma janela configurada
              </div>
              <div
                v-if="(row.item.config_atualizacao_resultados || []).length < 2"
                class="janela-add"
              >
                <CriarConfiguracaoUpdateEnquetes :categoria="row.item" />
              </div>
            </div>
          </td>
          <td class="tdActions">
            <div class="action-btn-group">
              <ModalRemoverCategoriaEnquete
                :id-categoria="row.item.id"
                @categoriaExcluida="handleCategoriaExcluida"
              />
            </div>
          </td>
        </tr>
        <tr :key="row.item.id" v-if="tab === 'cameras'">
          <td>{{ row.item.nome }}</td>
          <td>{{ row.item.endereco }}</td>
          <td class="tdActions">
            <div class="action-btn-group">
              <ModalEditarInfoCamera :camera-data="row.item" :is-on-admin="true" />
              <ModalExcluirCamera
                :id-camera="row.item.id"
                :cod-praca="row.item.cod_praca"
              />
            </div>
          </td>
        </tr>
        <tr :key="row.item.dat_log" v-if="tab === 'log'">
          <td>{{ row.item.dat_log | formatData }}</td>
          <td>{{ row.item.dsc_login_log }}</td>
          <td>
            {{
              row.item.dsc_tabela_alterada_log ? row.item.dsc_tabela_alterada_log : "-"
            }}
          </td>
          <td>{{ row.item.dsc_coluna_log ? row.item.dsc_coluna_log : "-" }}</td>
          <td>
            {{ row.item.dsc_valor_anterior_log ? row.item.dsc_valor_anterior_log : "-" }}
          </td>
          <td>{{ row.item.dsc_valor_novo_log ? row.item.dsc_valor_novo_log : "-" }}</td>
          <td>{{ row.item.dsc_operacao_log ? row.item.dsc_operacao_log : "ROTAÇÃO" }}</td>
        </tr>
        <tr :key="row.item.cod_conta_bloqueada" v-if="tab === 'contas'">
          <td>{{ row.item.dsc_colaborador_user }}</td>
          <td>{{ row.item.dsc_fonte_colaboracao }}</td>
          <td class="tdActions">
            <div class="action-btn-group">
              <ModalAdicionarOuEditarContaBloqueada
                :key="row.item.dsc_colaborador_user"
                :getContasBloqueadas="fetchData"
                :editFormData="row.item"
                :isEditarForm="true"
              />
              <ModalExcluirContaBloqueada
                :getContasBloqueadas="fetchData"
                :key="row.item.cod_conta_bloqueada"
                :cod_conta_bloqueada="row.item.cod_conta_bloqueada"
              />
            </div>
          </td>
        </tr>
        <tr :key="row.item.cod_palavra_bloqueada" v-if="tab === 'palavras'">
          <td>{{ row.item.dsc_palavra }}</td>
          <td class="tdActions">
            <div class="action-btn-group">
              <ModalAdicionarOuEditarPalavraBloqueada
                :getPalavrasBloqueada="fetchData"
                :key="row.item.dsc_palavra"
                :editFormData="row.item"
                :isEditarForm="true"
              />
              <ModalExcluirPalavraBloqueada
                :getPalavrasBloqueadas="fetchData"
                :key="row.item.cod_palavra_bloqueada"
                :cod_palavra_bloqueada="row.item.cod_palavra_bloqueada"
              />
            </div>
          </td>
        </tr>
        <tr :key="row.item.cod_coluna" v-if="tab === 'colunas'">
          <td>{{ row.item.dsc_coluna }}</td>
          <td>{{ row.item.num_coluna_telao }}</td>
          <td>{{ row.item.flg_ativo ? "S" : "N" }}</td>
          <td class="tdActions">
            <div class="action-btn-group">
              <ModalEditarColuna
                :changeColuna="changeColuna"
                :num_coluna_telao="num_coluna_telao"
                :item="row.item"
                :key="row.item.cod_coluna"
              />
            </div>
          </td>
        </tr>
        <tr :key="row.item.cod_pasta" v-if="tab === 'pastas'">
          <td>{{ row.item.dsc_nome_pasta }}</td>
          <td class="tdActions">
            <div class="action-btn-group">
              <ModalAdicionarOuEditarPastas
                :editFormData="row.item"
                :key="row.item.cod_pasta"
                :isEditarForm="true"
                :getPastas="fetchData"
              />
            </div>
          </td>
        </tr>
      </template>

      <template v-slot:[`header.name`]="{ header }">
        {{ header.text }}
      </template>
    </v-data-table>

    <EditarProducao
      :dialog="showModalEdicao"
      :modal-data="dadosAtuais"
      :fetchData="fetchData"
      @close="hideModal()"
    />
  </div>
</template>

<script>
import EditarProducao from "./Modal/Producao/EditarProducao.vue";
import ExcluirProducao from "./Modal/Producao/ExcluirProducao.vue";
import ExcluirAprovador from "./Modal/Aprovador/ExcluirAprovador.vue";
import CampanhaProducao from "./Modal/Producao/CampanhaProducao.vue";
import ModalExcluirContaBloqueada from "./Modal/ContaBloqueada/ModalExcluirContaBloqueada.vue";
import ModalExcluirPalavraBloqueada from "./Modal/PalavraBloqueada/ModalExcluirPalavraBloqueada.vue";
import ModalAdicionarOuEditarContaBloqueada from "./Modal/ContaBloqueada/ModalAdicionarOuEditarContaBloqueada.vue";
import ModalAdicionarOuEditarPalavraBloqueada from "./Modal/PalavraBloqueada/ModalAdicionarOuEditarPalavraBloqueada.vue";
import ModalEditarColuna from "./Modal/Colunas/ModalEditarColuna.vue";
import ModalAdicionarOuEditarPastas from "./Modal/Pastas/ModalAdicionarOuEditarPastas.vue";
import ModalRemoverCategoriaEnquete from "./Modal/Enquetes/ModalRemoverCategoriaEnquete.vue";
import EditarConfiguracaoUpdateEnquetes from "./Modal/Enquetes/EditarConfiguracaoUpdateEnquetes.vue";
import ModalEditarInfoCamera from "./Modal/Camera/ModalEditarInfoCamera.vue";
import ModalExcluirCamera from "./Modal/Camera/ModalExcluirCamera.vue";
import CriarConfiguracaoUpdateEnquetes from "./Modal/Enquetes/CriarConfiguracaoUpdateEnquetes.vue";
import ModalRemoverConfiguracaoUpdateEnquetes from "./Modal/Enquetes/ModalRemoverConfiguracaoUpdateEnquetes.vue";

export default {
  props: {
    headers: Array,
    data: Array,
    filtro_texto: String,
    itensPorPagina: Number,
    tab: String,
    fetchData: Function,
    changeColuna: Function,
    num_coluna_telao: Number,
  },
  components: {
    EditarProducao,
    ExcluirProducao,
    ExcluirAprovador,
    CampanhaProducao,
    ModalExcluirContaBloqueada,
    ModalExcluirPalavraBloqueada,
    ModalAdicionarOuEditarContaBloqueada,
    ModalAdicionarOuEditarPalavraBloqueada,
    ModalEditarColuna,
    ModalAdicionarOuEditarPastas,
    ModalRemoverCategoriaEnquete,
    EditarConfiguracaoUpdateEnquetes,
    ModalEditarInfoCamera,
    ModalExcluirCamera,
    CriarConfiguracaoUpdateEnquetes,
    ModalRemoverConfiguracaoUpdateEnquetes,
  },
  data() {
    return {
      isModelVisible: false,
      loading: true,
      value_names: ["sig_producao", "desc_producao", "cod_producao"],
      footerProps: {
        itemsPerPageText: "Linhas por página",
        itemsPerPageAllText: "Tudo",
        itemsPerPageOptions: [5, 10, 25, 50, -1],
        pageText: "{0}-{1} de {2}",
      },
      headerProps: {
        mobile: true,
        checkboxColor: "success--text",
      },
      dadosAtuais: {},
      showModalEdicao: false,
    };
  },
  filters: {
    perfisToString(perfisArr) {
      let perfis = [];
      for (const perfil of perfisArr) {
        perfis.push(perfil.dsc_perfil);
      }
      return perfis.join("\n");
    },
    formatData(data) {
      let date = new Date(data);
      return date.toLocaleString("pt-br");
    },
  },
  created() {
    if (this.data) {
      this.loading = false;
    }
  },
  methods: {
    openModalEdicao(item) {
      this.dadosAtuais = item;
      this.showModalEdicao = true;
    },
    hideModal() {
      this.showModalEdicao = false;
    },
    async handleCategoriaExcluida() {
      this.$emit("categoriaExcluida");
    },
    formatCadence(seconds) {
      if (seconds == null) return "";
      if (seconds < 60) return `${seconds} seg`;
      const minutes = Math.round(seconds / 60);
      return `${minutes} min`;
    },
    padHour(hour) {
      if (hour === null || hour === undefined || hour === "") return "";
      return String(hour).padStart(2, "0");
    },
  },
};
</script>

<style lang="scss" scoped>
/* Table container */
.table {
  border-radius: var(--sc-radius-lg);
  overflow: hidden;
  background-color: var(--v-surface_tertiary-base) !important;
}

/* Header */
::v-deep .v-data-table-header {
  background-color: var(--sc-surface-tint) !important;

  th {
    color: var(--v-text_secondary-base) !important;
    font-size: 0.75rem !important;
    font-weight: 600 !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid var(--sc-border-subtle) !important;
    height: 44px !important;
  }
}

/* Rows */
::v-deep tbody {
  tr {
    background: var(--v-surface_tertiary-base) !important;
    transition: background var(--sc-duration-fast) var(--sc-easing-standard);

    &:hover {
      background: var(--sc-surface-tint) !important;
    }

    td {
      color: var(--v-text_primary-base) !important;
      font-size: var(--sc-text-base);
      border-bottom: 1px solid var(--sc-border-subtle) !important;
    }
  }
}

/* Footer */
::v-deep .v-data-footer {
  background: var(--v-surface_tertiary-base) !important;
  border-top: 1px solid var(--sc-border-subtle) !important;
  padding: 6px 16px;
  min-height: 40px;
  font-size: 0.8rem;
  color: var(--v-text_secondary-base);
  justify-content: flex-end;

  .v-data-footer__select {
    font-size: 0.8rem;
    color: var(--v-text_secondary-base);
    margin: 0 !important;

    .v-select {
      margin: 0 8px !important;
    }

    .v-input {
      margin-top: 0 !important;
      padding-top: 0 !important;
    }

    .v-input__slot {
      min-height: 28px !important;
      background: transparent !important;
      border: 1px solid var(--sc-border-default);
      border-radius: var(--sc-radius-sm);
      padding: 0 8px !important;

      &:hover {
        border-color: rgba(255, 255, 255, 0.2);
      }
    }

    .v-select__selections {
      font-size: 0.8rem;
      color: var(--v-text_primary-base);
    }

  }

  .v-data-footer__pagination {
    font-size: 0.8rem;
    color: var(--v-text_secondary-base);
    margin: 0 12px;
  }

  .v-data-footer__icons-before,
  .v-data-footer__icons-after {
    .v-btn {
      width: 28px;
      height: 28px;
      margin: 0 1px;

      &.v-btn--disabled {
        opacity: 0.25;
      }

      .v-icon {
        font-size: 18px;
        color: var(--v-text_secondary-base);
      }

      &:hover:not(.v-btn--disabled) .v-icon {
        color: var(--v-text_primary-base);
      }
    }
  }
}

/* Actions column */
td.tdActions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  height: 68px !important;
  padding: 8px 16px 8px 0 !important;
}

.action-btn-group {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.enquete-row > td {
  padding-top: var(--sc-space-3) !important;
  padding-bottom: var(--sc-space-3) !important;
  vertical-align: middle;
  border-bottom: thin solid var(--sc-border-medium) !important;
}

.enquete-row > td.tdActions {
  display: table-cell !important;
  height: auto !important;
  text-align: right;

  .action-btn-group {
    justify-content: flex-end;
  }
}

.janelas-list {
  display: flex;
  flex-direction: column;
  gap: var(--sc-space-1);
  width: fit-content;
  min-width: 220px;
}

.janela-row {
  display: flex;
  align-items: center;
  gap: var(--sc-space-2);
  height: 28px;
}

.janela-range {
  font-weight: var(--sc-weight-semi);
  font-size: var(--sc-text-base);
  min-width: 76px;
}

.janela-sep {
  color: var(--sc-color-text-tertiary);
  font-size: var(--sc-text-base);
}

.janela-cadence {
  color: var(--sc-color-text-secondary);
  font-size: var(--sc-text-md);
  min-width: 48px;
}

.janela-actions {
  display: inline-flex;
  align-items: center;
  gap: var(--sc-space-1);
  margin-left: auto;
  padding-left: var(--sc-space-3);

  ::v-deep .table-action-box {
    width: 24px;
    height: 24px;
    min-width: 24px;
    padding: 0;
    border-radius: var(--sc-radius-sm);
    flex-direction: row;
    justify-content: center;
    background: transparent;
    transition: background var(--sc-duration-fast) var(--sc-easing-standard);

    &:hover {
      background: var(--sc-surface-tint-strong);
    }

    .v-icon {
      margin: 0 !important;
      color: var(--sc-color-text-secondary);
    }
  }

  ::v-deep .table-action-label {
    display: none;
  }
}

.janela-empty {
  color: var(--sc-color-text-tertiary);
  font-style: italic;
  font-size: var(--sc-text-md);
  padding: 0 var(--sc-space-2);
  height: 28px;
  display: flex;
  align-items: center;
}

.janela-add {
  margin-top: var(--sc-space-1);

  ::v-deep .table-action-box {
    width: auto;
    height: 26px;
    min-width: 0;
    padding: 0 var(--sc-space-2);
    border-radius: var(--sc-radius-sm);
    flex-direction: row;
    gap: var(--sc-space-1);
    background: transparent;
    border: none;
    color: var(--sc-color-primary);
    justify-content: flex-start;
    transition: background var(--sc-duration-fast) var(--sc-easing-standard);

    &:hover {
      background: rgba(var(--sc-color-primary-rgb), 0.08);
    }

    .v-icon {
      margin: 0 !important;
      color: var(--sc-color-primary);
    }
  }

  ::v-deep .table-action-label {
    font-size: var(--sc-text-md);
    margin: 0;
    text-transform: none;
    letter-spacing: 0;
    color: var(--sc-color-primary);
  }
}

// .table-action-label now lives in _action-box.scss

/* Production name cell */
.td-nome {
  font-weight: var(--sc-weight-regular);
  color: var(--v-text_primary-base) !important;
}

/* Sigla chip (secondary identifier) */
.prod-sigla-chip {
  display: inline-block;
  font-size: var(--sc-text-sm);
  font-weight: var(--sc-weight-semi);
  letter-spacing: var(--sc-tracking-caps);
  color: var(--v-text_secondary-base);
  background: var(--sc-surface-tint-hover);
  border: 1px solid var(--sc-border-default);
  border-radius: var(--sc-radius-sm);
  padding: var(--sc-space-1) var(--sc-space-2);
}

/* Active / inactive status badge */
.prod-status {
  display: inline-flex;
  align-items: center;
  font-size: var(--sc-text-sm);
  font-weight: var(--sc-weight-semi);
  border-radius: var(--sc-radius-pill, 999px);
  padding: var(--sc-space-1) var(--sc-space-3);

  &--ativa {
    color: var(--v-primary-base);
    background: rgba(var(--sc-color-primary-rgb), 0.12);
  }

  &--inativa {
    color: var(--v-text_secondary-base);
    background: var(--sc-surface-tint-hover);
  }
}

/* Campaigns overflow */
.tdCampanha {
  overflow-y: auto;
  max-height: 2.9rem;
}

/* Remove default elevation */
::v-deep .v-data-table {
  box-shadow: none !important;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 4px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--sc-surface-tint-stronger);
}
</style>
